import React, { useEffect, useState } from "react";
import { globalVars } from "../global/GlobalVars.js";
import { index } from "mathjs";

//========================================================================
// für Datenpunkte anmelden
const registerDataPoints = (ws, reqDataValues, regUnreg) => {
  let sndData;

  if (regUnreg === "register") {
    sndData = JSON.stringify({
      action: "registerDataPoints",
      values: reqDataValues,
    });
  } else if (regUnreg === "unregister") {
    sndData = JSON.stringify({
      action: "unregisterDataPoints",
    });
  } else {
    console.error("Fehler: Registrierung oder Abmeldung nicht definiert");
  }

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
    // console.log("Datenpunkte angemeldet: ", sndData);
  }
};

//========================================================================
// über Websocket Daten senden
const sendData = (ws, id, value, oldValue, user) => {
  const sndData = JSON.stringify({
    action: "writeValue",
    value: {
      id: id,
      value: value,
      oldValue: oldValue,
      user: user,
    },
  });

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
    // console.log("Daten gesendet: ", sndData);
  }
};

//========================================================================
// Alarme quittieren
const quittAlarm = (ws, quittMode, index) => {
  // console.log(quittMode, index);
  const sndData = JSON.stringify({
    action: "quittAlarm",
    quittMode: quittMode,
    index: index,
  });

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
    // console.log("Daten gesendet: ", sndData);
  }
};

//========================================================================
// Alarmkonfiguration anfordern
const getAlarmConfig = (ws) => {
  const sndData = JSON.stringify({
    action: "getAlarmConfig",
  });

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
  }
};

//========================================================================
// Alarmkonfiguration aktualisieren
const updateAlarmConfig = (ws, newConfig) => {
  const sndData = JSON.stringify({
    action: "updateAlarmConfig",
    newConfig: newConfig,
  });

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
  }
};

//========================================================================
// alle aufgezeichneten Datenpunkte anfordern
const getAllHisoricData = (ws) => {
  const sndData = JSON.stringify({
    action: "getAllHistoricData",
  });
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
  }
};

//========================================================================
// historische Daten anfordern
const getHystoricData = (ws, reqHistData) => {
  const sndData = JSON.stringify({
    action: "getHystoricData",
    reqHistData: reqHistData,
  });
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
  }
};

//========================================================================
// Liste der gespeicherten Charts anfordern
const getSavedChartsList = (ws) => {
  const sndData = JSON.stringify({
    action: "getSavedChartsList",
  });

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
  }
};

//========================================================================
// gespeicherte Charts anfordern
const getSavedCharts = (ws, reqSavedCharts) => {
  const sndData = JSON.stringify({
    action: "getSavedCharts",
    reqSavedCharts: reqSavedCharts,
  });

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
  }
};

//========================================================================
// Charts speichern
const saveCharts = (ws, name) => {
  const chartsToSave = {
    name: name,
    chartDataPoints: globalVars.chartDataPoints,
    chartColors: globalVars.chartColors,
  };
  const sndData = JSON.stringify({
    action: "saveCharts",
    saveCharts: chartsToSave,
  });

  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(sndData);
  }
};

//========================================================================
// Funktionen exportieren
export {
  sendData,
  registerDataPoints,
  quittAlarm,
  getAllHisoricData,
  getHystoricData,
  getSavedChartsList,
  getSavedCharts,
  saveCharts,
  getAlarmConfig,
  updateAlarmConfig,
};
